import React from 'react'

interface Props{
  isTownPlanning: boolean,
  scriptData: any,
  townPlanningFilter: string,
  angle: number,
  attributesData: any
}

interface State{
  showLayouts: boolean,
  townplanning: any
}

class TownPlanningLayouts extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showLayouts: false,
      townplanning: {}
    }
  }

  componentDidMount(): void {
    this.setState({
      showLayouts: true,
      townplanning: this.props.scriptData.townPlanning_coord_file
    }, () => {
      this.props.attributesData.forEach((attribute: any) => {
        if(attribute.type === 'Hierarchical'){
          var currentName = attribute.name
          attribute.values.forEach((value: any) => {
            this.props.scriptData.townPlanning_coord_file.forEach((frame: any) => {
              frame[currentName].forEach((frameProperty: any) => {
                if(value.id === frameProperty.id){
                  var c: any;
                  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.billboardFill)){
                      c= value.billboardFill.substring(1).split('');
                      if(c.length === 3){
                          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                      }
                      c= '0x'+c.join('');
                      frameProperty.billboardFill = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
                  }
                  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.layoutFill)){
                    c= value.layoutFill.substring(1).split('');
                    if(c.length === 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    frameProperty.layoutFill = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.45)';
                    frameProperty.layoutStroke = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.8)';
                }
                  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.billboardStroke)){
                    c= value.billboardStroke.substring(1).split('');
                    if(c.length === 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    frameProperty.billboardStroke = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.45)';
                }
                  //frameProperty.billboardFill = value.billboardFill
                  //frameProperty.billboardStroke = value.billboardStroke
                  //frameProperty.layoutFill = value.layoutFill
                }
              })
            })
          })
        }
      })
    })
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.scriptData !== prevProps.scriptData && this.props.scriptData.townPlanning_coord_file){
      this.setState({
        townplanning: this.props.scriptData.townPlanning_coord_file
      }, () => {
        this.props.attributesData.forEach((attribute: any) => {
          if(attribute.type === 'Hierarchical'){
            var currentName = attribute.name
            attribute.values.forEach((value: any) => {
              this.props.scriptData.townPlanning_coord_file.forEach((frame: any) => {
                frame[currentName].forEach((frameProperty: any) => {
                  if(value.id === frameProperty.id){
                    var c: any;
                    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.billboardFill)){
                        c= value.billboardFill.substring(1).split('');
                        if(c.length === 3){
                            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                        }
                        c= '0x'+c.join('');
                        frameProperty.billboardFill = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
                    }
                    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.layoutFill)){
                      c= value.layoutFill.substring(1).split('');
                      if(c.length === 3){
                          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                      }
                      c= '0x'+c.join('');
                      frameProperty.layoutFill = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.45)';
                      frameProperty.layoutStroke = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.8)';
                  }
                    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(value.billboardStroke)){
                      c= value.billboardStroke.substring(1).split('');
                      if(c.length === 3){
                          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                      }
                      c= '0x'+c.join('');
                      frameProperty.billboardStroke = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.45)';
                  }
                    //frameProperty.billboardFill = value.billboardFill
                    //frameProperty.billboardStroke = value.billboardStroke
                    //frameProperty.layoutFill = value.layoutFill
                  }
                })
              })
            })
          }
        })

      })
    }
    if(prevProps.isTownPlanning !== this.props.isTownPlanning && this.props.isTownPlanning){
      this.createLayouts()
      this.setState({
        showLayouts: true
      })
    }
    if(this.props.townPlanningFilter !== prevProps.townPlanningFilter){
      this.createLayouts()
    }
    if(this.props.angle !== prevProps.angle){
      this.createLayouts()
    }
    if(prevProps.isTownPlanning !== this.props.isTownPlanning && !this.props.isTownPlanning){
      this.createLayouts()
      this.setState({
        showLayouts: false
      })
    }
  }

  createLayouts = () => {
    if(this.props.townPlanningFilter !== ""){
      if(this.props.scriptData.townPlanning_coord_file && this.props.scriptData.townPlanning_coord_file[this.props.angle]){
        if(this.props.scriptData.townPlanning_coord_file[this.props.angle][this.props.townPlanningFilter]){
          return(
            this.props.scriptData.townPlanning_coord_file[this.props.angle][this.props.townPlanningFilter].map((data: any, index: number) => 
              data.verts.length === 4 && data.layoutFill ?
              
              <polygon
                  key={index + "layouts"}
                  points = {
                    data.verts[0][0] + "," + data.verts[0][1] + " " +
                    data.verts[1][0] + "," + data.verts[1][1] + " " +
                    data.verts[3][0] + "," + data.verts[3][1] + " " +
                    data.verts[2][0] + "," + data.verts[2][1] + " " 
                  }
                  style={{
                    cursor: "pointer",
                    fill: data.layoutFill !== null ? data.layoutFill:'rgba(0,0,0,0)',
                    stroke: data.layoutStroke !== null ? data.layoutStroke:'rgba(0,0,0,0)',
                    strokeWidth: 2
                  }}
                >

              </polygon>:null
            )
          )
        }
      }
    }
    return(
      <div></div>
    )
  }

  createBillboards = () => {
    if(this.props.townPlanningFilter !== ""){
      if(this.props.scriptData.townPlanning_coord_file && this.props.scriptData.townPlanning_coord_file[this.props.angle]){
        if(this.props.scriptData.townPlanning_coord_file[this.props.angle][this.props.townPlanningFilter]){
          return(
            this.props.scriptData.townPlanning_coord_file[this.props.angle][this.props.townPlanningFilter].map((data: any, index: number) => 
              data.verts.length === 2 ?
              <React.Fragment>
                <circle
                  cx={data.verts[0]}
                  cy={data.verts[1]}
                  r="30"
                  style={{
                    cursor: 'pointer',
                    fill: data.billboardFill,
                    stroke: data.billboardStroke,
                    strokeWidth: 2,
                  }}
                  
                />
                
                {
                  this.props.attributesData.map((attribute: any) => 
                    attribute.name === this.props.townPlanningFilter ?
                      attribute.values.map((value: any) => 
                        value.id === data.id ?
                        value.value.split(" ").map((splited: any, index: number) => 
                          <text
                          x={data.verts[0]}  
                          y={data.verts[1] + 18 * index} 
                          width="30"
                          height="30"
                          fontFamily={index === 0 ? "Montserrat Semibold" :"Montserrat Regular" }
                          text-anchor="middle"
                          fontSize="15" 
                          fill="black"
                          >
                            {splited}
                          </text>
                        ):null
                      ):null 
                    
                  )
                }
                </React.Fragment>:null
            )
          )
        }
      }
    }
    return(
      <div></div>
    )
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isTownPlanning ? 'layouts-townplanning fade-in':'layouts-townplanning fade-out'}>
          {
            this.state.showLayouts ?
            <svg
                width={"100%"}
                height={"100%"}
                preserveAspectRatio="xMidYMid slice"
                viewBox="0 0 1400 2000"
                style={{
                  overflow: 'hidden',
                  pointerEvents: 'none',
                  position: 'absolute',
                }}
              >
                <g
              style={{
                pointerEvents: this.props.isTownPlanning ? 'visibleFill':'none'
              }}
            >
              {this.createLayouts()}
            </g>
            </svg>:null
          }
          {
            this.state.showLayouts ?
            <svg
            width={'100%'}
            height={'100%'}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 1400 2000"
            style={{
              overflow: 'hidden',
              pointerEvents: 'none',
              position: 'absolute',
            }}
            >
              <g
              style={{
                pointerEvents: 'visibleFill',
              }}>
                {this.createBillboards()}
              </g>
            </svg>:null
          }
        </div>
      )
  }
}

export default TownPlanningLayouts